import React, { useRef } from 'react';
import { CompetitionTab } from './competitionView';

const LABEL: Record<CompetitionTab, string> = { overview: 'Overview', submit: 'Submit', leaderboard: 'Leaderboard' };

interface Props { tabs: CompetitionTab[]; active: CompetitionTab; onChange: (tab: CompetitionTab) => void }

const CompetitionTabs: React.FC<Props> = ({ tabs, active, onChange }) => {
  const refs = useRef<Partial<Record<CompetitionTab, HTMLButtonElement | null>>>({});
  const move = (from: CompetitionTab, step: number) => {
    const next = tabs[(tabs.indexOf(from) + step + tabs.length) % tabs.length];
    onChange(next);
    refs.current[next]?.focus();
  };
  return (
    <div className="competition-tabs" role="tablist" aria-label="Competition sections" data-tour="competition-tabs">
      {tabs.map((tab) => (
        <button key={tab} type="button" role="tab" id={`competition-tab-${tab}`} aria-controls={tab === active ? `competition-panel-${tab}` : undefined}
          aria-selected={tab === active} tabIndex={tab === active ? 0 : -1}
          ref={(el) => { refs.current[tab] = el; }}
          className={`competition-tabs__tab${tab === active ? ' competition-tabs__tab--active' : ''}`}
          onClick={() => onChange(tab)}
          onKeyDown={(e) => {
            if (e.key === 'ArrowRight') { e.preventDefault(); move(tab, 1); }
            if (e.key === 'ArrowLeft') { e.preventDefault(); move(tab, -1); }
            if (e.key === 'Home') { e.preventDefault(); move(tabs[0], 0); }
            if (e.key === 'End') { e.preventDefault(); move(tabs[tabs.length - 1], 0); }
          }}>
          {LABEL[tab]}
        </button>
      ))}
    </div>
  );
};

export default CompetitionTabs;
